const router = [
  {
    path: "/kelola/instansi/:instansi_id/diklat",
    name: "diklat",
    meta: {
      auth: true
    },
    component: () => import("./pages/List")
  },
];

export default router;
